import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var JusticeHammerSvg = function JusticeHammerSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.272 1.475 5.346 5.31L14.585 9.8l6.778 6.735-.992.986-6.778-6.735-3.032 3.013-5.345-5.313zm0 1.97-5.073 5.04 3.362 3.341 5.073-5.04zM13.642 16.829H3.366l-2.003 4.646h14.283zM3.49 20.08l.801-1.858h8.426l.801 1.858z",
    clipRule: "evenodd"
  }));
};
export var JusticeHammer = function JusticeHammer(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: JusticeHammerSvg
  }));
};